import React from 'react';
import sortBy from 'lodash/sortBy';
import { useSelector } from 'react-redux';
import { ExternalLink } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { MenuLinkStyled } from '@yme/components/Header/Megamenu/styled';
import { useTouchOnly } from '@yme/hooks/useTouchOnly';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
import { getIsExternalLink } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
import OfferCards from '../OfferCards';
import { MegamenuListItemStyled, MegamenuListStyled } from '../styled';
import { MenuItemWithSubMenu } from './MenuItemWithSubMenu';
import { TwoLevelMenuCardStyled, TwoLevelMenuStyled, TwoLevelMenuWrapperStyled } from './styled';
export function TwoLevelMenu({ navItems, offersModel, isTwoLevelsView, closeMenuHandler, label, }) {
    const isRightToLeft = useSelector(getRTL);
    const isTouchDevice = useTouchOnly();
    return (React.createElement(TwoLevelMenuWrapperStyled, null,
        React.createElement(TwoLevelMenuStyled, { isRightToLeft: isRightToLeft },
            React.createElement(MegamenuListStyled, { isRightToLeft: isRightToLeft }, sortBy(navItems, (item) => !item.childPages?.length)?.map((item) => {
                const { childPages, title, link, onClick } = item;
                const isExternalLink = getIsExternalLink(link);
                return childPages.length ? (React.createElement(MenuItemWithSubMenu, { item: item, closeMenuHandler: closeMenuHandler, label: label, isTwoLevelsView: isTwoLevelsView })) : (React.createElement(MegamenuListItemStyled, { key: title, isTouchDevice: isTouchDevice, isRightToLeft: isRightToLeft, isLink: true },
                    React.createElement("span", null,
                        React.createElement(MenuLinkStyled, { to: {
                                pathname: link,
                            }, target: isExternalLink ? BLANK : SELF, onClick: () => onClick(link), isRightToLeft: isRightToLeft },
                            title,
                            isExternalLink && (React.createElement(SVGIcon, { size: ICON_SIZE.xxs, pathFill: colorCoreBlack900Base, type: ExternalLink }))))));
            }))),
        offersModel && (React.createElement(TwoLevelMenuCardStyled, { height: "100%", paddingDesktop: isRightToLeft
                ? `${INDENT.sm} 0 ${INDENT.sm} ${INDENT.xl}`
                : `${INDENT.sm} ${INDENT.xl} ${INDENT.sm} 0`, paddingTablet: `${INDENT.xs} ${INDENT.sm} ${INDENT.sm}`, paddingMobile: `${INDENT.xs} ${INDENT.xs} ${INDENT.sm}` },
            React.createElement(OfferCards, { ...offersModel, isSmallCardHidden: true, closeMenuHandler: closeMenuHandler })))));
}
